import { ReactElement } from 'react';
import { WaterCard } from './components/WaterCard';
import { getRowCardOrders } from '../helpers/cards';
import { RowCardContainer } from './components/styles';
import { Energy } from './Energy';
import { useMediaQuery } from '~/hooks/useMediaQuery';

interface RowCardsOverviewProps {
  hasWater: boolean,
  hasEnergy: boolean,
  loading: boolean,
  order: number
}

export function RowCardsOverview({
  hasEnergy,
  hasWater,
  loading,
  order,
}: Readonly<RowCardsOverviewProps>): ReactElement {
  const { water } = getRowCardOrders(hasWater);
  const direction = hasWater ? 'row' : 'column';
  const isMobile = useMediaQuery('(max-width: 768px)');
  const expanded = !isMobile && !hasEnergy;

  return (
    <RowCardContainer direction={direction} style={{ order }}>
      <WaterCard
        hasWater={hasWater}
        loading={loading}
        order={water}
        expanded={expanded}
      />
      <Energy
        hasEnergy={hasEnergy}
        hasWater={hasWater}
        loading={loading}
      />
    </RowCardContainer>
  );
}
